// ======================================================================
// File Name       : top
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as actionTypes from '../constants/ActionTypes';

const initialState = {
  noticeEnterprise: null,
  noticeService: null,
  systemNotice: {
    recordNum: 0,
    noticeList: [],
  },
  serviceDetailUserList: [],
};

export default function noticeTop(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ENTERPRISE_NOTICE_LIST:
      { const { systemNotice } = action;
        return { ...state, systemNotice }; }
    case actionTypes.ENTERPRISE_NOTICE_DETAIL:
      { const { noticeEnterprise } = action;
        return { ...state, noticeEnterprise }; }
    case actionTypes.SERVICE_NOTICE_DETAIL:
      { const { noticeService } = action;
      return { ...state, noticeService }; }
    default:
      return state;
  }
}
